import React from 'react';

const ArrowIcon: React.FC = () => {
  return (
    <svg
      width="16"
      height="18"
      viewBox="0 0 16 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.6103 1.2334L14.6758 1.18525L14.6272 0.109603L13.5521 0.168319L13.6103 1.2334ZM5.05146 10.7209L4.40559 11.5697L6.10337 12.8615L6.74925 12.0126L5.05146 10.7209ZM7.98291 0.472463L6.91783 0.53063L7.03416 2.66079L8.09924 2.60262L7.98291 0.472463ZM12.8345 7.69546L12.8827 8.76104L15.0138 8.66473L14.9657 7.59915L12.8345 7.69546ZM12.7614 0.587521L5.05146 10.7209L6.74925 12.0126L14.4592 1.87928L12.7614 0.587521ZM13.5521 0.168319L7.98291 0.472463L8.09924 2.60262L13.6684 2.29848L13.5521 0.168319ZM12.5447 1.28155L12.8345 7.69546L14.9657 7.59915L14.6758 1.18525L12.5447 1.28155ZM2.46989 13.8002L0.265593 16.569L1.9346 17.8978L4.1389 15.129L2.46989 13.8002Z"
        fill="#424245"
      />
    </svg>
  );
};

export default ArrowIcon;
